module.exports = __webpack_public_path__ + "img/yellow_pet_warning.da9f24c3.svg";